export function escapeHtml(unsafe: string): string {
    return unsafe
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
}

export function normalizeApiBase(publicApiBaseUrl?: string): string {
    return publicApiBaseUrl ? publicApiBaseUrl.replace(/\/$/, '') : '';
}
